module.exports = (state, action) => {
  const filterData = action.payload

  for (const activityId in state.activities) {
    const activity = state.activities[activityId]
    const filterValue = filterData.value
    const filterType = filterData.type
    state.activitySearchValue = filterValue

    if (filterType === 'text') {
      if (activity.title.indexOf(filterValue) === -1) {
        state.activities[activityId].visible = false
      } else {
        state.activities[activityId].visible = true
      }
    } else if (filterType === 'Label') {
      if (filterValue.indexOf(activity.boxId) === -1) {
        state.activities[activityId].visible = false
      } else {
        state.activities[activityId].visible = true
      }
    } else if (filterType === 'Box') {
      if (filterData.value === activity.boxId) {
        state.activities[activityId].visible = true
      } else {
        state.activities[activityId].visible = false
      }
    }
  }
}
